import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./global.css"; 
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { Auth0Provider } from "@auth0/auth0-react";

const isLoopbackHost = (hostname = "") =>
  hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1";

const isPrivateIpv4Host = (hostname = "") =>
  /^10\./.test(hostname) ||
  /^192\.168\./.test(hostname) ||
  /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);

const isPrivateNetworkHost = (hostname = "") =>
  isLoopbackHost(hostname) ||
  isPrivateIpv4Host(hostname) ||
  hostname.endsWith(".local");

const isRunningLocally = isPrivateNetworkHost(window.location.hostname);
const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL || "";

if (configuredApiBaseUrl) {
  try {
    const parsedUrl = new URL(configuredApiBaseUrl);
    axios.defaults.baseURL =
      !isRunningLocally && isPrivateNetworkHost(parsedUrl.hostname)
        ? ""
        : parsedUrl.origin;
  } catch {
    axios.defaults.baseURL = configuredApiBaseUrl.includes("localhost") && !isRunningLocally
      ? ""
      : configuredApiBaseUrl.replace(/\/\.netlify\/?$/, "");
  }
} else {
  axios.defaults.baseURL = "";
}

const root = ReactDOM.createRoot(document.getElementById("root"));

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN?.trim();
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID?.trim();
const hasAuth0Config = Boolean(auth0Domain && auth0ClientId);
const resolvedAuth0Domain = auth0Domain || "example.auth0.com";
const resolvedAuth0ClientId = auth0ClientId || "placeholder-client-id";

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain={resolvedAuth0Domain}
      clientId={resolvedAuth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: "openid profile email",
      }}
      skipRedirectCallback={!hasAuth0Config}
    >
      <App />
    </Auth0Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
